var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',[_c('app-heading',{attrs:{"title":"Features"}}),_c('app-row',[_c('app-cell',[_c('app-data-table',{attrs:{"items":_vm.features,"total":_vm.count,"headers":_vm.headers},on:{"update":_vm.fetchFeatures}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }